// import Color from 'color';
// Facade
import Facade from 'core/Facade';

export const createData = sites => sites.map((site,index) => {
    const newDataset = {
        backgroundColor: colors[index],
        borderCapStyle: 'butt',
        borderColor: colors[index],
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'round',
        data: [],
        fill: false,
        label: Facade.siteDisplayName(site.name),
        lineTension: 0,
        pointBackgroundColor: colors[index],
        pointBorderColor: colors[index],
        pointBorderWidth: 5,
        pointHitRadius: 10,
        pointHoverBackgroundColor: colors[index],
        pointHoverBorderColor: colors[index],
        pointHoverBorderWidth: 2,
        pointHoverRadius: 8,
        pointRadius: 1,
        spanGaps: false
    };

    newDataset.data = site.records.map(performance => {
        const date = new Date(performance.date.slice(0, 10));

        const dataUnit = {
            x: date,
            y: performance.orderCount
        };

        return dataUnit;
    });

    return newDataset;
});

const colors = [
    '#eb4034',
    '#eb8f34',
    '#ebd634',
    '#a5eb34',
    '#34eb65',
    '#34ebcd',
    '#3480eb',
    '#6534eb',
    '#d334eb',
    '#eb3471',
    '#080003',
    '#4f6566',
    '#66584f',
    '#1f6922',
    '#593155',
    '#ede5a8',
    '#edaca8'
];
